const EMPTY_VALUE_TEXT = '-'

export { EMPTY_VALUE_TEXT }